"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocalStorage = void 0;
exports.setLocalStorage = function (key, value) {
    try {
        localStorage.setItem(key, value);
    }
    catch (e) { }
};
//# sourceMappingURL=set-local-storage.js.map